<template>
  <div>
    <!-- <app-monev_topbar></app-monev_topbar>
    <app-monev_left_sidebar></app-monev_left_sidebar>-->
    <section class="content">
      <div class="container-fluid">
        <div class="row clearfix">
          <div class="bg-light-green" style="margin-top:-1% !important;">
            <!-- <br> -->
            <div class="row paddingku">
              <div class="col-md-3 searching">
                <span class="h_page">Registrasi User</span>
                <br>
                <br>
              </div>
              <div class="col-md-6"></div>
              <div class="col-md-3 searching">
                <div class="input-group">
                  <span class="input-group-btn">
                    <button type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" disabled>
                      <i class="material-icons">search</i>
                    </button>
                  </span>
                  <input type="text" class="form-control" placeholder="Cari data" id="caridata" @keyup="cari_data" v-model="cari_value">
                </div> <br>
              </div>
            </div>
          </div>
          <div class="col-xs-12 card">
      <!-- ============================================================ MULAI ======================================================================== -->
            <br>
          <!-- ============================================================ TABEL ======================================================================== -->
            <div class="table-responsive">
              <table class="table table-bordered" style="width: 100%">
                <thead>
                  <tr class="bg-info">
                    <th class="text-center" style="width: 5%">No.</th>
                    <th class="text-center" style="width: 20%">Nama</th>
                    <th class="text-center" style="width: 20%">NIP</th>
                    <th class="text-center" style="width: 40%">Instansi</th>
                    <th class="text-center" style="width: 15%">#</th>
                  </tr>
                </thead>
                <tbody>

                    <!-- <template v-for="dn_akun in data.akun_detil" track-by="data11._id" > -->
                      <tr class="h_isitable" v-for="(data, index) in list_data" :key="data.id">
                        <td class="text-center">{{index+1}}.</td>
                        <td>{{data.bio_nama}}</td>
                        <td class="text-center">{{data.nama_nip}}</td>
                        <td>{{data.unit_kerja}}</td>
                        <td class="text-center">
                          <button @click="getProfile(data.nama_nip)" class="btn bg-light-blue btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_lihat_data">
                            <i class="material-icons">search</i>
                          </button>
                          &nbsp;
                          <button @click="getProfile(data.nama_nip)" class="btn bg-light-green btn-xs waves-effect" title="Aktifasi User" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                            <i class="material-icons">assignment_late</i>
                          </button>
                        </td>
                      </tr>
                    <!-- </template> -->

                </tbody>

              </table>

            </div>
          <!-- ============================================================ TABEL ======================================================================== -->
            <hr>


            <div class="text-center">
              <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                <i class="material-icons">skip_previous</i>
              </button>

              <span style="font-size: 85%; color: #a5a5a5">
                <b>{{page_first}} - {{page_last}}</b>
              </span>

              <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                <i class="material-icons">skip_next</i>
              </button>
            </div>
            <hr>

        <!-- ============================================================ MODAL ======================================================================== -->


          <!-- =========================================================== EDIT ================================================================= -->
            <!-- </div> -->
            <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog">
              <div class="modal-dialog modal-md" role="document">
                <div class="modal-content">
                  <div class="modal-header bg-light-green">
                    <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                  </div>
                  <div class="modal-body">
                    <div v-if="errorMessage" class="alert alert-danger" role="alert">{{ errorMessage }}</div>

                   

                    <div class="row clearfix">
                      <div class="col-md-3 form-control-label">
                      </div>
                      <div class="col-md-9">
                            <div class="table-responsive">
                              <table style="width: 100%">
                                <tr>
                                  <td style="width: 50%">
                                    <div class="demo-radio-button">
                                        <div class="demo-checkbox">
                                            <input type="checkbox" v-model="profile.AdminOPD" id="basic_checkbox_1_a" class="filled-in" ><label for="basic_checkbox_1_a">Admin OPD</label> <br>
                                            <input type="checkbox" v-model="profile.KonsepSurat" id="basic_checkbox_1" class="filled-in" ><label for="basic_checkbox_1">Konsep Surat</label> <br>
                                            <input type="checkbox" v-model="profile.ValidasiSurat" id="basic_checkbox_2" class="filled-in" ><label for="basic_checkbox_2">Validasi Surat</label><br>
                                            <input type="checkbox" v-model="profile.TeruskanSurat" id="basic_checkbox_3" class="filled-in" ><label for="basic_checkbox_3">Teruskan Surat</label><br>
                                        </div>
                                    </div>
                                  </td>

                                   <td style="width: 50%">
                                    <div class="demo-radio-button">
                                        <div class="demo-checkbox">
                                            <input type="checkbox" v-model="profile.BacaSurat" id="basic_checkbox_7" class="filled-in" ><label for="basic_checkbox_7">Baca Surat</label> <br>
                                            <input type="checkbox" v-model="profile.DisposisiSurat" id="basic_checkbox_8" class="filled-in" ><label for="basic_checkbox_8">Disposisi Surat</label><br>
                                            <input type="checkbox" v-model="profile.TtdSurat" id="basic_checkbox_9" class="filled-in" ><label for="basic_checkbox_9">TTD Surat</label><br>
                                        </div>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </div>
                            
                      </div>
                    </div>


                  </div>
                  <div class="modal-footer">
                    <button @click="activeData" type="button" class="btn btn-success waves-effect">AKTIFKAN</button>
                    <button
                      type="button"
                      class="btn btn-danger waves-effect"
                      data-dismiss="modal"
                    >KEMBALI</button>
                  </div>
                </div>
              </div>
            </div>
          <!-- =========================================================== EDIT ================================================================= -->
        


          <!-- =========================================================== LIHAT ================================================================= -->
            <div class="modal fade" id="m_lihat_data" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
              <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                  <div class="modal-header bg-light-blue">
                    <h4 class="modal-title" id="largeModalLabel">DETIL DATA</h4>
                  </div>
                    <div class="modal-body">
                      <hr>
                      <transition name="fade">
                        <div v-if="modal_profile">
                          <profil_user></profil_user>
                        </div>
                      </transition>
                      
                  </div>
                  <div class="modal-footer">
                    <button @click="closeProfile()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal" >KEMBALI</button>
                  </div>
                </div>
              </div>
            </div>
          <!-- =========================================================== LIHAT ================================================================= -->



        <!-- ============================================================ MODAL ======================================================================== -->




      <!-- ============================================================ MULAI ======================================================================== -->
          </div>
        </div>
      </div>
    </section>
  </div>
</template>


<script>
// const ADD_URL = URL_APP + "auth/signup";


import Joi from "joi";
const ADD_URL = URL_APP + "api/v1/reg_registrasi/";
const ACTIVE_URL = URL_APP + "api/v1/office_aktivasi/";
const SIGNUP_URL = URL_APP + "auth/signup";




const schema = Joi.object().keys({
  username: Joi.string().regex(/^[a-zA-Z0-9_]*$/).min(3).max(13).required(),
  password: Joi.string().min(6).required(),
});


export default {

  name : 'monev_user',
  data: function() {
    return {
      profile:{
        id : "",
        unit_kerja : "",
        unit_kerja_id : "",
        nama : "",
        nama_nip : "",

        KonsepSurat : true,
        ValidasiSurat : false,
        TeruskanSurat : false,
        BacaSurat : false,
        DisposisiSurat : false,
        TtdSurat : false,
        AdminOPD : false,

        unit_kerja_alamat :'',
        bio_nama :'',
        bio_gelar_depan :'',
        bio_gelar_belakang :'',
        bio_tempat_lahir :'',
        bio_ttl :'',
        bio_gol :'',
        bio_jabatan :'',
        bio_alamat :'',
      },

      modal_profile : false,

      list_data: [],
      page_first: 1,
      page_last: 0,
      cari_value: "",

      signingUp : false,
      errorMessage: "",
    };
  },

  methods: {
    getView: function() {
      fetch(ADD_URL + "view", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({
          data_ke: this.page_first,
          cari_value: this.cari_value
        })
      })
        .then(res => res.json())
        .then(res_data => {
          this.list_data = res_data.data;
          this.page_last = res_data.jml_data;
          console.log(res_data);
        });
    },

    activeData: function() {
      fetch(ACTIVE_URL + "add", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({
            nama_nip: this.profile.nama_nip,
            KonsepSurat : this.profile.KonsepSurat,
            ValidasiSurat : this.profile.ValidasiSurat,
            TeruskanSurat : this.profile.TeruskanSurat,
            BacaSurat : this.profile.BacaSurat,
            DisposisiSurat : this.profile.DisposisiSurat,
            TtdSurat : this.profile.TtdSurat,
            AdminOPD : this.profile.AdminOPD,
        })
      }).then(res_data => {
        console.log(res_data);
        
        this.getView();
        this.alertku("success", "sukses meperbaharui Level");
      });
    },

    // getEdit: function(username, id, unit_kerja, unit_kerja_id, nama, nama_nip, Office, Planing, Simpeg, Bhumie, Aset, Monev, Berita, Pengaduan, Sakip, CCTV, Linja, Registrasi, unit_kerja_alamat, bio_nama, bio_gelar_depan, bio_gelar_belakang, bio_tempat_lahir, bio_ttl, bio_gol, bio_jabatan, bio_alamat) {

        //     this.dataku.username = username;
        //     this.profile.id = id;
        //     this.profile.unit_kerja = unit_kerja;
        //     this.profile.unit_kerja_id = unit_kerja_id;
        //     this.profile.nama = nama;
        //     this.profile.nama_nip = nama_nip;
        //     this.profile.Office = Office;
        //     this.profile.Planing = Planing;
        //     this.profile.Simpeg = Simpeg;
        //     this.profile.Bhumie = Bhumie;
        //     this.profile.Aset = Aset;
        //     this.profile.Monev = Monev;
        //     this.profile.Berita = Berita;
        //     this.profile.Pengaduan = Pengaduan;
        //     this.profile.Sakip = Sakip;
        //     this.profile.CCTV = CCTV;
        //     this.profile.Linja = Linja;
        //     this.profile.Registrasi = Registrasi;
        //     this.profile.unit_kerja_alamat = unit_kerja_alamat;
        //     this.profile.bio_nama = bio_nama;
        //     this.profile.bio_gelar_depan = bio_gelar_depan;
        //     this.profile.bio_gelar_belakang = bio_gelar_belakang;
        //     this.profile.bio_tempat_lahir = bio_tempat_lahir;
        //     this.profile.bio_ttl = bio_ttl;
        //     this.profile.bio_gol = bio_gol;
        //     this.profile.bio_jabatan = bio_jabatan;
        //     this.profile.bio_alamat = bio_alamat;
    // },

    getProfile(id){
      localStorage.profile_id = id;
      this.profile.nama_nip =id;
      this.modal_profile = true;

    },
    closeProfile(){
      localStorage.profile_id = "";
      this.modal_profile = false;
    },

  // ================== PAGINASI ====================
    alertku: function(type, title) {
      this.$swal({
        type: type,
        title: title,
        showConfirmButton: false,
        timer: 800
      });
    },

    btn_prev: function() {
      if (this.page_first > 1) {
        this.page_first--;
      } else {
        this.page_first = 1;
      }
      this.getView();
    },

    btn_next: function() {
      if (this.page_first >= this.page_last) {
        this.page_first == this.page_last;
      } else {
        this.page_first++;
      }
      this.getView();
    },

    cari_data: function() {
      this.getView();
    },
    getNama : function(){
      var unit_Kerja = document.getElementById("unit_kerja_id").value;
      this.autocompleted1(unit_Kerja)
    },


  // ================== PAGINASI ====================
  },

  watch: {
        dataku: {
            handler() {
                this.errorMessage = "";
            },
            deep: true
        }
  },
  mounted: function() {
    localStorage.sidemenu = 'registrasi';
    this.getView();
  }
};
</script>

<style>
</style>
